import { render, staticRenderFns } from "./ResearchDataTableFeatures.vue?vue&type=template&id=704e750e"
import script from "./ResearchDataTableFeatures.vue?vue&type=script&lang=js"
export * from "./ResearchDataTableFeatures.vue?vue&type=script&lang=js"
import style0 from "./ResearchDataTableFeatures.vue?vue&type=style&index=0&id=704e750e&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('704e750e')) {
      api.createRecord('704e750e', component.options)
    } else {
      api.reload('704e750e', component.options)
    }
    module.hot.accept("./ResearchDataTableFeatures.vue?vue&type=template&id=704e750e", function () {
      api.rerender('704e750e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchDataTableFeatures.vue"
export default component.exports